import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BillingService } from '../../../services/billing/billing.service';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { Date_range } from '../../../core/models/date-range';
import * as dayjs from 'dayjs';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-payed-leads',
	templateUrl: './payed-leads.component.html',
	styleUrls: ['./payed-leads.component.scss'],
})
export class PayedLeadsComponent implements OnInit {
	@ViewChild(DatatableComponent) table: DatatableComponent;

	payed_leads: any[];
	loading: boolean;
	columnMode = ColumnMode;

	fromDate: NgbDate | null;
	toDate: NgbDate | null;

	// Search NGX Datatable
	temp = [];
	columns: any[];
	sumLeadCost = 0;

	dateRange_: Date_range = {
		dateStart: dayjs(new Date()).subtract(1, 'month'),
		dateEnd: dayjs(new Date()),
	};

	pageSize = 20;
	curPage = 1;

	constructor(
		private billingSrv: BillingService,
		public formatter: NgbDateParserFormatter,
		private http: HttpClient,
	) {
		this.loading = false;
		this.columns = [
			{
				name: 'Agent',
				prop: 'agent_name',
				showed: false,
			},
			{
				name: 'Alias',
				prop: 'alias',
				showed: true,
			},
			{
				name: 'Prospect',
				prop: 'prospect_company',
				showed: true,
			},
		];
	}

	ngOnInit(): void {
		this.getPayedLeads();
	}

	getPayedLeads() {
		this.loading = true;
		const start_date = this.dateRange_.dateStart.format('YYYY-MM-DD');
		const end_date = this.dateRange_.dateEnd.format('YYYY-MM-DD');
		this.billingSrv.getAllPayed(start_date, end_date).subscribe((data: any) => {
			if (data == null) {
				this.loading = false;
				this.payed_leads = [];
				this.sumLeadCost = 0;
				return;
			}
			this.payed_leads = data.body;
			this.temp = [...this.payed_leads];
			this.sumLeadCost = this.payed_leads.reduce((total, lead) => total + lead.lead_cost, 0);
			this.loading = false;
		});
	}

	getCellClassCampaign({ row, column, value }): any {
		return {
			' back-cell-gray content-point': row['id'] > 0,
		};
	}

	dateSelected() {
		this.getPayedLeads();
	}

	searchNgxDatatable(event, props: string) {
		const val = event.target.value.toLowerCase();
		const propArray = props.split(',');
		const temp = this.temp.filter(function (d) {
			return propArray.some((prop) => {
				return d[prop].toString().toLowerCase().indexOf(val) !== -1 || !val;
			});
		});

		this.payed_leads = temp;
		this.sumLeadCost = this.payed_leads.reduce((total, lead) => total + lead.lead_cost, 0);
		this.table.offset = 0;
	}

	// Resize the Table on sidebar show or hide
	recalculate() {
		this.table.recalculate();
	}

	showHideColumns(columnProp) {
		const obj = this.columns.find((column) => {
			return column.prop === columnProp;
		});
		return obj.showed;
	}

	getCellClassOptions({ row, column, value }): any {
		return {
			' cellForButtons': row['id'] > 0,
		};
	}

	undoPayment(row: any) {
		Swal.fire({
			title: 'Are you sure?',
			text: 'Do you want to undo this payment?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Yes, undo it!',
		}).then((result) => {
			if (result.isConfirmed) {
				const payload = { lead_id: row.lead_id };

				this.billingSrv.undoPayment(payload).subscribe({
					next: (res: any) => {
						Swal.fire('Undone!', 'Payment has been undone successfully.', 'success');
						this.getPayedLeads();
					},
					error: (err) => {
						console.error(err);
						Swal.fire('Error', 'Error undoing payment', 'error');
					},
				});
			}
		});
	}

	get totalPages(): number {
		return Math.ceil(this.payed_leads.length / this.pageSize) || 1;
	}

	get pagedPayedLeads() {
		const start = (this.curPage - 1) * this.pageSize;
		return this.payed_leads.slice(start, start + this.pageSize);
	}

	get pageNumbers(): number[] {
		return Array.from({ length: this.totalPages }, (_, i) => i + 1);
	}

	goToPage(page: number) {
		if (page < 1 || page > this.totalPages) return;
		this.curPage = page;
	}

	prevPage() {
		this.goToPage(this.curPage - 1);
	}

	nextPage() {
		this.goToPage(this.curPage + 1);
	}
}
